// Copyright (c) 2016 Deere & Company

import {
    addFile,
    deleteFile
} from './file-attachment';
import {
    addLabor,
    changeLaborLocation,
    changeLaborProperty,
    changeLaborType,
    deleteLabor
} from './labor';
import {
    addPart,
    changePartProperty,
    changePartsUnit,
    deletePart
} from './parts';
import {
    changeAmount,
    changeComments,
    changeDescription,
    changeDistance,
    createOtherCredit,
    deleteOtherCredit
} from './other-credits';
import {
    onCreateClaim,
    updateClaimModalMode,
    updateCreateClaimModalVisibility
} from './create-claim-modal-visibility';
import {
    resetAttachmentClaim,
    updateAttachmentClaimFailureDate,
    updateAttachmentClaimFailurePart,
    updateAttachmentClaimInputOnBlur,
    updateAttachmentClaimProperty,
    updateAttachmentClaimRepairDate,
    updateAttachmentClaimRepairNumber,
    updateAttachmentClaimWorkOrderOne,
    updateAttachmentClaimWorkOrderTwo,
    updateOwnershipStatusDropDown,
    updateResponsibleAccountsDropDown,
    updateStickyHeaderVisibility
} from './claim-details';
import {
    resetConfirmationModal,
    setConfirmationModal
} from './confirmation-modal';
import {
    updateAttachmentClaimBasisForSettlement,
    updateAttachmentClaimComplaintCause,
    updateAttachmentClaimComplaintCorrection,
    updateAttachmentClaimDtacCase,
    updateAttachmentClaimDtacSolution,
    updateAttachmentClaimFailedArea,
    updateAttachmentClaimFailedModeComments,
    updateAttachmentClaimOperatorComments,
    updateAttachmentClaimOperatorsComplaint,
    updateDownTimeDropDown,
    updateFailedModeDropDown
} from './failure-panel';
import {additionalRepair} from './additional-repair';
import {copyAttachments} from '../../shared/action-creators/copy-attachment';
import {copyClaim} from './copy-claim';
import {createAttachmentClaim} from './validate-claim';
import {onEditClaim} from '../../shared/action-creators/edit-claim';
import {readAttachmentClaim} from './get-attachment-claim';
import {readClaimTypes} from './get-claim-types';
import {readDownTime} from '../../shared/action-creators/down-time';
import {readFailureModes} from './failure-modes';
import {readGoodsInstallationVatOptions} from '../../shared/action-creators/get-goods-installation-vat-options';
import {readLaborLocations} from '../../shared/action-creators/labor-locations';
import {readLaborTypes} from '../../shared/action-creators/labor-types';
import {readOtherCreditDescriptions} from '../../shared/action-creators/other-credit-descriptions';
import {readOwnershipStatuses} from '../../shared/action-creators/ownership-status';
import {readPartDetails} from './get-part-details';
import {updateGoodsInstallationVat} from './update-goods-installation-vat';
import {updateIsEditable} from './is-editable';
import {updateSelectedAction} from './update-selected-action';
import {updateTemporaryObjectKey} from './update-temporary-object-key';
import {validateItemNumber} from './validate-item-number';

export default {
    addFile,
    addLabor,
    addPart,
    additionalRepair,
    changeAmount,
    changeComments,
    changeDescription,
    changeDistance,
    changeLaborLocation,
    changeLaborProperty,
    changeLaborType,
    changePartProperty,
    changePartsUnit,
    copyAttachments,
    copyClaim,
    createAttachmentClaim,
    createOtherCredit,
    deleteFile,
    deleteLabor,
    deleteOtherCredit,
    deletePart,
    onCreateClaim,
    onEditClaim,
    readAttachmentClaim,
    readClaimTypes,
    readDownTime,
    readFailureModes,
    readGoodsInstallationVatOptions,
    readLaborLocations,
    readLaborTypes,
    readOtherCreditDescriptions,
    readOwnershipStatuses,
    readPartDetails,
    resetAttachmentClaim,
    resetConfirmationModal,
    setConfirmationModal,
    updateAttachmentClaimBasisForSettlement,
    updateAttachmentClaimComplaintCause,
    updateAttachmentClaimComplaintCorrection,
    updateAttachmentClaimDtacCase,
    updateAttachmentClaimDtacSolution,
    updateAttachmentClaimFailedArea,
    updateAttachmentClaimFailedModeComments,
    updateAttachmentClaimFailureDate,
    updateAttachmentClaimFailurePart,
    updateAttachmentClaimInputOnBlur,
    updateAttachmentClaimOperatorComments,
    updateAttachmentClaimOperatorsComplaint,
    updateAttachmentClaimProperty,
    updateAttachmentClaimRepairDate,
    updateAttachmentClaimRepairNumber,
    updateAttachmentClaimWorkOrderOne,
    updateAttachmentClaimWorkOrderTwo,
    updateClaimModalMode,
    updateCreateClaimModalVisibility,
    updateDownTimeDropDown,
    updateFailedModeDropDown,
    updateGoodsInstallationVat,
    updateIsEditable,
    updateOwnershipStatusDropDown,
    updateResponsibleAccountsDropDown,
    updateSelectedAction,
    updateStickyHeaderVisibility,
    updateTemporaryObjectKey,
    validateItemNumber
};



// WEBPACK FOOTER //
// ./src/claim/attachment/action-creators/index.js